import React from "react";
import { ProductController } from "./ProductController";
import { ProductViewModel } from "./ProductViewModel";
import * as feedback from "../../common/Feedback/Feedback";
import * as log from "../../common/Feedback/Log";

export class ProductProvider extends React.Component {
  constructor(props) {
    super(props);
    this.viewModel = new ProductViewModel();
    this.logger = log;
    this.feedback = feedback;

    console.log(props);
  }

  render() {
    return (
      <ProductController
        viewModel={this.viewModel}
        log={this.logger}
        feedback={this.feedback}
        toggleTopbar={this.props.toggleTopbar}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Products/ProductProvider.js